import { getAppConfig } from "services/configService";
import { GET } from "services/httpService";
import urlJoin from "url-join";

const apiUrl = () => {
  return getAppConfig().OrderCutOffApiUrl;
};

export const getArticleGroups = requestInfo => {
  return GET(requestInfo, urlJoin(apiUrl(), "/v1/ArticleGroup"));
};

export const getCutOffCampaignByName = (requestInfo, campaignName) => {
  return GET(requestInfo, urlJoin(apiUrl(), `/v1/Campaign/${campaignName}`));
};
